module.exports = require("./lrc-IR");